<template>
  <div class="gj-top-tabs">
    <div class="gj-top-tabs-box">
      <div class="tabs-header">
        <span v-for="item in tabs"
          :key="item.id"
          :class="[tabsActive === item.id ? 'active' : '']"
          class="tabs-header-item"
          @click="clickTabs(item.id)">
          {{item.text}}
        </span>
      </div>
      <div class="tabs-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gj-app-top-tabs",
  props: {
    value: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: () => ([])
    },
    type: null,
  },
  watch: {
    value (val, oldVal) {
      if (val !== oldVal) {
        this.tabsActive = val
      }
    },
    tabsActive (val, oldVal) {
      if (val !== oldVal) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      tabsActive: this.value
    }
  },
  methods: {
    clickTabs(id) {
      this.tabsActive = id;
    }
  }
}
</script>

<style lang="scss" scoped>
.gj-top-tabs {
  width: 100%;
  height: 100%;
  // padding: 10px 20px;
  box-sizing: border-box;
  .gj-top-tabs-box {
    background-color: #ffffff;
    // padding: 0 10px;
    // border-radius: 4px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    height: 100%;
    .tabs-header {
      border-bottom: 1px solid #e8e8e8;
      width: 100%;
      .tabs-header-item {
        display: inline-block;
        text-align: center;
        height: 32px;
        line-height: 36px;
        box-sizing: border-box;
        cursor: pointer;
        font-size: 13px;
        color: #666;
        transition: all 0.3s;
        border-bottom: 2px solid transparent;
        margin-right: 32px;
      }
      .tabs-header-item.active {
        border-bottom: 2px solid #1F6EEF;
        color: #1F6EEF;
      }
    }
    .tabs-content {
      width: 100%;
      // height: calc(100% - 33px);
    }
  }
}
</style>